import React from 'react';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import Loader from '../../components/Loader';
import useDialogConfig from '../_hooks/useDialogConfig';
import ProjectVisibilityDialog from '../../dialogs/project.visibility';

export default function Launcher(props) {
  const config = useDialogConfig();

  const project = useConnect('project.byId', {
    id: config.params.projectId
  });

  if (project.state === PayloadStates.FETCHING) {
    return (
      <Loader />
    );
  }

  return (
    <ProjectVisibilityDialog
      project={project}
      onCancel={props.onClose}
    />
  );
};
